import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  BlacklistReportRequest,
  BlacklistReportResponse,
  RmBlacklistReportApi,
} from '../tokens/rm-blacklist-report.token';

/**
 * REST-only implementation of {@link RmBlacklistReportApi} (EM-699 / F7 — EM-712).
 *
 * Thin {@code HttpClient} wrapper over the B5 report path of the live
 * {@code LenderBlacklistResource} (EM-703 / B4) at
 * {@code /services/embedded/api/v1/blacklist/reports}. No mock (Rules 07/10);
 * the RM's only blacklist write path (add/remove/restore are SM/CRO-only → 403).
 * Rides the Keycloak bearer via {@code authInterceptor}. Consumed by
 * {@code features/lender-rm/blacklist/} through the {@link RM_BLACKLIST_REPORT} token.
 */
@Injectable()
export class RmBlacklistReportRestService implements RmBlacklistReportApi {
  private readonly http = inject(HttpClient);

  report(request: BlacklistReportRequest): Observable<BlacklistReportResponse> {
    return this.http.post<BlacklistReportResponse>(API_PATHS.BLACKLIST_REPORTS, request);
  }
}
